import React from 'react'
import cartData from './../models/cart.js'

import InputMask from 'react-input-mask'

import { AddressInput } from './address_input.component'
import { LoginButton } from '../../profile/login_button.component'

import { MessageComponent } from '../../shared/dialog/message.component'

import {
  DialogComponent
} from '../../shared/dialog/dialog.component'

import {
  AdditionalFields
} from './additional_fields.component'

import {
  PickupConds,
  DeliveryPeriods,
  DeliveryDateChoose
} from './delivery_conds.component'

import { PaymentsConds } from './payments_conds.component'
import singletons from '../../shared/singletons'
import { SelectComponent } from '../../shared/select/select.component'

import { orderApi } from './order_api'
import { loginApi } from '../../profile/login/login_api'

import { sharedData } from '../../../models/shared_data'

import { OrderBonusApply } from './order_bonus_apply.component'
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component'

import { districtsApi } from './districts_api'

export class MakeOrderComponent extends React.Component {
  constructor(props) {
    super(props)
    cartData.subject
      .subscribe(()=> {
        this.forceUpdate()
      })

    const settings = props.params.cart_settings
    this.state = {
      smartPeriods: [],
      smartPeriodCurrentId: null,
      coupledDialogOpened: false,
      order: props.params.order,
      payment_info: {
        payment_type: (settings.mobile_only_payment ? 'card' : props.params.order.payment_type_symbol),
        card_id: null,
        cvn: ''
      },
      errors: {
        client: {},
        order: {}
      },
      orderSent: false,
      cvn_error: false
    }


    setTimeout(()=> {
      this.setFirstCard()
    }, 300)

    this.delivery_periods_ref = null
    this.delivery_date_ref = null

    this.orderChanged = this.orderChanged.bind(this)
    this.addressChanged = this.addressChanged.bind(this)
    this.deliveryChanged = this.deliveryChanged.bind(this)
    this.paymentsChanged = this.paymentsChanged.bind(this)
    this.openLogin = this.openLogin.bind(this)
    this.periodChanged = this.periodChanged.bind(this)
    this.makeOrder = this.makeOrder.bind(this)
    this.dateChanged = this.dateChanged.bind(this)
    this.setBonuses = this.setBonuses.bind(this)
    this.makeOrderAndPay = this.makeOrderAndPay.bind(this)
    this.addCoupledItems = this.addCoupledItems.bind(this)
    this.closeCoupledDialog = this.closeCoupledDialog.bind(this)
    this.changeCVN = this.changeCVN.bind(this)

    this.districtChanged = this.districtChanged.bind(this)
    this.smartPeriodChanged = this.smartPeriodChanged.bind(this)

    cartData.subject.subscribe(()=> {
      this.refillOrder()
    })

    sharedData.subject
      .subscribe(()=> {
        this.forceUpdate()
        this.refillOrder()
      })
  }

  correctDates() {
    if(this.delivery_date_ref) {
      this.delivery_date_ref.changed()
    }

    if(this.delivery_periods_ref) {
      this.delivery_periods_ref.componentWillMount()
    }
  }

  refillOrder() {

    orderApi.refreshCart(this.state.order, this.state.payment_info.payment_type)
      .subscribe((data)=> {
        const op = data.order_params
        const settings = op.cart_settings
        this.setState({
          order: op.order,
          payment_info: {
            payment_type: op.order.payment_type_symbol,
            card_id: null,
            cvn: ''
          },
          errors: {
            client: {},
            order: {}
          },
          orderSent: false
        }, ()=> {
          singletons['loading'].start()
          setTimeout(()=> {
            singletons['loading'].stop()
            // this.correctDates()
          }, 200)
          this.setFirstCard()
          this.forceUpdate()
        })
      })
  }

  allowedCards() {
    if(sharedData.data.client) {
      return sharedData.data.client.cards
    } else {
      return []
    }
  }

  setFirstCard() {
    const cards = this.allowedCards()
    if(cards.length > 0 && !this.state.payment_info.card_id) {
      this.setState((ps)=> {
        ps.payment_info.card_id = cards[0].id
        return ps
      })
    }
  }

  openLogin(e) {
    e.preventDefault()
    singletons['login'].open()
  }

  componentWillMount() {
    this.subscr = cartData.subject.subscribe((x)=> {
      this.forceUpdate()
    })
  }

  addressChanged(addr) {
    this.setState((ps)=> {
      ps.order.address = addr
      return ps
    })
  }

  deliveryChanged(ord) {

  }

  paymentsChanged(payment_type) {
    this.setState((ps)=> {
      ps.payment_info.payment_type = payment_type
      return ps
    })
  }

  orderChanged(name, e) {
    if(e.preventDefault)
      e.preventDefault()
    const v = e.target ? e.target.value : e
    this.setState((ps)=> {
      ps.order[name] = v
      return ps
    })
  }

  periodChanged(p) {
    this.setState((ps)=> {
      ps.order.time_from = p.from
      ps.order.time_to = p.to
      return ps
    })
  }

  dateChanged(d) {
    this.setState((ps)=> {
      ps.order.date = d
      return ps
    }, ()=> {
      if(this.state.order.date)
        this.loadDistrictParams()
    })
  }

  componentWillUnmount() {
    this.subscr.unsubscribe()
  }

  thankYou() {
    this.setState((ps)=> {
      ps.orderSent = true
      return ps
    })
  }

  setErrors(errs) {
    this.setState({
      errors: errs
    })
    // this.errors = errs
    // console.log(errs)
  }

  addCoupledItems(e) {
    e.preventDefault()
    window.location.href='/cart/add_coupled'
  }

  isFioCorrect() {
    let fio = this.state.order.fio.toString().trim()

    if(fio.split(' ').length > 1) {
      this.setState({
        errors: {
          client: {},
          order: {}
        }
      })
      return true
    }

    this.setState({
      errors: {
        client: {},
        order: {
          fio: 'Введите Фамилию и Имя'
        }
      }
    })

    alert('Введите Имя и Фамилию через пробел')
    return false
  }

  makeOrder(e, force = false) {
    e.preventDefault()

    if(!this.isFioCorrect()) {
      return
    }

    if(!force && this.state.order.need_coupled_items) {
      this.setState({
        coupledDialogOpened: true
      })
      return
    } else {
      this.setState({
        coupledDialogOpened: false
      })
    }
    if(sharedData.data.client) {
      this.setState({
        errors: {
          client: {},
          order: {}
        }
      })
      orderApi.makeOrder(this.state.order)
        .subscribe((data)=> {
          if(data.status == 'ok') {
            cartData.clear({orderMade: true})
            // Here we need to call our hook!
            if(sharedData.data.site_params.site_order_jscode.length > 0) {
              eval(sharedData.data.site_params.site_order_jscode)
            }
            this.thankYou()
          }
          else {
            this.setErrors(data.errors)
          }
        })
    } else {
      singletons['login'].open(this.state.order.phone)
    }
  }

  getCardId() {
    return this.state.payment_info.card_id
  }

  getCVN() {
    return this.state.payment_info.cvn
  }

  makeOrderAndPay(e, force = false) {
    e.preventDefault()

    if(this.needCvn() && this.state.payment_info.cvn.length != 3) {
      this.setState({
        cvn_error: true
      })
      return
    }

    if(!force && this.state.order.need_coupled_items) {
      this.setState({
        coupledDialogOpened: true
      })
      return
    }

    if(sharedData.data.client) {
      this.setState({
        errors: {
          client: {},
          order: {}
        }
      })
      orderApi.makeOrder(this.state.order, { pay: true, card_id: this.getCardId(), cvn: this.getCVN() })
        .subscribe((data)=> {
          if(data.status == 'ok')
            this.thankYou()
          if(data.status == 'redirect') {
            singletons['loading'].start()
            window.location.href = data.redirect
          }
          else {
            this.setErrors(data.errors)
          }
        })
    } else {
      singletons['login'].open(this.state.order.phone)
    }
  }

  isError(name) {
    if(this.state.errors.order[name])
      return ' error '
    return ''
  }

  setBonuses(bonuses) {
    this.setState((ps)=> {
      ps.order.bonus_sum = bonuses
      return ps
    })
  }

  canAndNeedPay(sum) {
    const sp = sharedData.data.site_params
    const able = sp.payment_system && sp.payment_system != '' && sp.payment_system != 'turned_off'
    const is_card_payment = this.state.payment_info.payment_type == 'card'

    return is_card_payment && able && sum > 0
  }

  needToAssignCard() {
    const sp = sharedData.data.site_params

    const is_card_payment = this.state.payment_info.payment_type == 'card'

    const able = sp.payment_system_assign_card_before_payment
    return is_card_payment && able && this.dontHaveCards()
  }

  canAndNeedWithBonuses(sum) {
    return sum == 0
  }

  dontHaveCards() {
    return this.allowedCards().length == 1
  }

  needSelectCard() {
    return this.state.payment_info.payment_type == 'card' && this.allowedCards().length > 0
  }

  changeCard(e) {
    this.setState((ps)=> {
      ps.payment_info.card_id = e.target.value
      return ps
    })
  }

  isCVNError() {
    return this.state.cvn_error ? ' error ' : ''
  }

  changeCVN(e) {
    const v = e.target.value
    this.setState((ps)=> {
      ps.payment_info.cvn = v
      return ps
    })
  }

  needCvn() {
    return sharedData.data.site_params.payment_system == 'gateline'
  }

  closeCoupledDialog(e) {
    this.setState((ps)=> {
      ps.coupledDialogOpened = false
      return ps
    })
  }

  loadDistrictParams() {
    const prms = this.props.params.cart_settings
    if(prms.delivery_schedule_system != 'smart')
      return

    districtsApi.periods(
      this.state.order.district_id,
      this.state.order.date
    ).subscribe((data)=> {
      const dateArr = data.date.split('-')
      this.delivery_date_ref.setDate(
        dateArr
      )

      this.setState((ps)=> {

        ps.smartPeriods = data.periods
        ps.smartPeriodCurrentId = data.periods[0].id
        ps.order.date = dateArr.reverse().join('.')
        return ps
      }, ()=> {
        this.smartPeriodChanged({target:{value: data.periods[0].id}})
      })
    })
  }

  districtChanged(e) {
    this.setState((ps)=> {
      ps.order.district_id = e.target.value
      return ps
    }, ()=> {
      this.loadDistrictParams()
    })
  }

  smartPeriodChanged(e) {
    const id = e.target.value
    const period = this.state.smartPeriods.find(x => x.id == id)

    this.setState((ps)=> {
      ps.order.time_from = period.period[0]
      ps.order.time_to = period.period[1]
      ps.smartPeriodCurrentId = id
      return ps
    })
  }

  render() {
    let d = cartData.data
    let sum = cartData.sum()
    let ord = this.state.order
    let s = this.state
    const cards = this.allowedCards()
    const total = sum - s.order.bonus_sum
    const prms = this.props.params.cart_settings

    // TODO: Check is order paid?
    const m = {
      message: prms.mobile_after_order
    }
    if(s.orderSent) {
      return (
        <div className="make-order-form">
          <MessageComponent params={m}/>
        </div>
      )
    }

    if(cartData.cartTotalItems() == 0)
      return (
        <div></div>
      )
    const mask = sharedData.phone_mask
    const needToAssignCard = this.needToAssignCard()

    return (
      <form className="make-order-form" onSubmit={this.makeOrder}>
        <div className="make-order">
          <div className="container">
            { sharedData.data.site_params.design == 'water' &&
              <div className="partials">
                <div className="b-7 mt--40 ml--150"></div>

                <div className="b-9 ml-800 mt-120"></div>
              </div>
            }

            <div className="h1">
              Оформление заказа
            </div>
            { !sharedData.data.client &&
              <div>
                Если вы уже зарегистрированы,
                <LoginButton enterText="войдите на сайт"></LoginButton>
              </div>
            }
            <div className="make-order-actual-form">
              <div className="input-white">
                <input
                  className={"input-white__text" + this.isError('fio')}
                  placeholder="Фамилия Имя" type="text"

                  name="fio"
                  value={ord.fio}
                  onChange={(e)=> {this.orderChanged('fio', e)}}
                />
              </div>
              <div className="input-white">
                <InputMask
                  className="input-white__text"
                  placeholder="Телефон"
                  name="phone"
                  type="text"
                  value={ord.phone}
                  onChange={(e)=> {this.orderChanged('phone', e)}}
                  mask={mask}
                />
              </div>
              {/*
              <div className="input-white">
                <input
                  className="input-white__text"
                  placeholder="Email"
                  type="text"
                  value={ ord.email }
                  onChange={(e)=> {this.orderChanged('email', e)}}
                />
              </div>
              */}
              { prms.delivery_type == 'delivery_and_pickup' &&
                <div>
                  <SelectComponent
                    opts={prms.delivery_types}
                    value={ord.delivery_type}
                    onChange={ (e)=> { this.orderChanged('delivery_type', e) } }
                  />
                </div>
              }

              { ord.delivery_type == 'delivery' &&
                <AddressInput
                  onChange={this.addressChanged}
                  onDistrictChange={this.districtChanged}
                  address={ord.address}
                  params={prms}
                  order={ord}
                  error={s.errors.order['address']}
                />
              }
              { ord.delivery_type  == 'pickup' &&
                <PickupConds />
              }

              { ord.delivery_type == 'delivery' && prms.mobile_choose_date &&
                <DeliveryDateChoose ref={(e)=> this.delivery_date_ref = e} date={ord.date} onChange={this.dateChanged}/>
              }
              {
                prms.delivery_schedule_system == 'smart' &&
                <div>
                  <div>
                    <h4>Период доставки</h4>
                    <SelectComponent
                      opts={s.smartPeriods}
                      value={s.smartPeriodCurrentId}
                      onChange={ (e)=> { this.smartPeriodChanged(e) } }
                    />
                  </div>
                </div>
              }
              {
                prms.delivery_schedule_system == 'old' &&
                <div>
                  { ord.delivery_type == 'delivery' && prms.delivery_periods &&
                    <DeliveryPeriods
                      onChange={this.periodChanged}
                      ord={ord}
                      settings={prms}
                      ref={(e)=> this.delivery_periods_ref = e}
                    />
                  }
                </div>
              }

              { ord.additional_fields_collected.length > 0 &&
                <AdditionalFields ord={ord} errors={this.state.errors}/>
              }

              <PaymentsConds
                onChange={this.paymentsChanged}
                paymentType={s.payment_info.payment_type}
                settings={prms}
              />
              { this.needSelectCard() && !needToAssignCard &&
                <div className="mt-15">
                  <div className="h4">
                    Выберите карту для оплаты
                  </div>
                  <SelectComponent
                    opts={cards}
                    value={s.payment_info.card_id}
                    onChange={ (e)=> { this.changeCard(e) } }
                  />

                  { this.needCvn() &&
                    <div>
                      <input
                        className={"input-white__text" + this.isCVNError()}
                        placeholder="CVN" type="text"
                        name="cvn"
                        value={s.payment_info.cvn}
                        onChange={(e)=> {this.changeCVN(e)}}
                      />
                    </div>
                  }
                </div>
              }

              { needToAssignCard &&

                <div>
                  Для оплаты заказа вам необходимо сначала
                  &nbsp;
                  <a className="btn btn--red mr-10" href="/profile/cards/assign">привязать карту</a>

                </div>
              }

              <div className="mt-15">
                <textarea
                  className={"input-white__text" + this.isError('comment')}
                  placeholder="Ваш комментарий" type="text"
                  name="comment"
                  value={ord.comment}
                  onChange={(e)=> {this.orderChanged('comment', e)}}
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div className="make-order-bottom">
          <div className="container">
            { ord.need_coupled_items && prms.order_message && prms.order_message != '' &&
              <div>
                <div className="order-message" dangerouslySetInnerHTML={ {__html: prms.order_message} }>
                </div>
              </div>
            }

            <DialogComponent opened={s.coupledDialogOpened} onClose={this.closeCoupledDialog} height="220" width="600">
              <div className="dialog-coupled">
                <p dangerouslySetInnerHTML={ {__html: prms.order_message} }></p>

                <div className="dialog-coupled__buttons">
                  <a href="" onClick={this.addCoupledItems} className="btn btn--blue btn--blue-thin">{ prms.order_message_add_coupled }</a>
                  <span className="dialog-coupled__buttons-separator">или</span>
                  { this.canAndNeedPay(total) &&
                    <span>
                      <button className="btn btn--red mr-10" onClick={(e)=> this.makeOrderAndPay(e, true)}>Отправить заказ и оплатить</button>
                    </span>
                  }

                  { s.payment_info.payment_type != 'card' &&
                    <button className="btn btn--red" onClick={(e) => this.makeOrder(e, true)}>Отправить заказ</button>
                  }
                </div>
              </div>
            </DialogComponent>
            <OrderBonusApply changeBonus={this.setBonuses} sum={sum} order={s.order}/>


            { !needToAssignCard &&
              <div>
                { this.canAndNeedPay(total) &&
                  <span>
                    <button className="btn btn--red mr-10" onClick={(e)=> this.makeOrderAndPay(e)}>Отправить заказ и оплатить</button>
                  </span>
                }

                { this.canAndNeedWithBonuses(total) &&
                  <span>
                    <button className="btn btn--red mr-10" onClick={(e)=> this.makeOrderAndPay(e)}>Отправить заказ и оплатить бонусами</button>
                  </span>
                }

                { s.payment_info.payment_type != 'card' &&
                  <button className="btn btn--red" onClick={(e) => this.makeOrder(e)}>Отправить заказ</button>
                }
                { ord.need_coupled_items &&
                  <a href="" onClick={this.addCoupledItems} className="btn btn--blue btn--blue-thin">{ prms.order_message_add_coupled }</a>
                }
              </div>
            }




            <span className="to-pay">К оплате:
              <CurFormatComponent type="strong" price={sum - s.order.bonus_sum} />
            </span>


          </div>
        </div>
    </form>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/make_order.component.jsx